import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components';

export type IcdTransferGuardMode = 'pending' | 'recent';

interface IcdTransferGuardDialogProps {
  mode: IcdTransferGuardMode;
  onDismiss: () => void;
  onConfirm: () => void;
}

export function IcdTransferGuardDialog({
  mode,
  onDismiss,
  onConfirm,
}: IcdTransferGuardDialogProps) {
  const { t } = useTranslation();
  const isPending = mode === 'pending';

  return (
    <Dialog open onOpenChange={(open) => !open && onDismiss()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t(
              isPending
                ? 'result.icdTransferGuard.pendingTitle'
                : 'result.icdTransferGuard.recentTitle'
            )}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-foreground">
          {t(
            isPending
              ? 'result.icdTransferGuard.pendingDescription'
              : 'result.icdTransferGuard.recentDescription'
          )}
        </DialogDescription>
        <DialogFooter className="flex-row justify-end">
          <Button variant="secondary" onClick={onDismiss}>
            {t(isPending ? 'result.icdTransferGuard.later' : 'result.icdTransferGuard.review')}
          </Button>
          <Button onClick={onConfirm}>{t('result.export')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
